import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, inject } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter } from "@angular/router";
import { provideGroundworksAuth } from "@groundworks/ngx-groundworks-auth";
import { IMAGEKIT_THUMBNAIL_CONFIG } from "@groundworks/ngx-groundworks-ui";
import { routes } from "./app.routes";
import { API_BASE_URL } from "./sdk/sdk";
import { ConfigService } from "./config.service";
import { buildGroundworksAuthConfig, resolveApiUrl } from "./auth.config";
import { ImageKitThumbnailConfigFactory } from "./factories/imagekit-thumbnail-config-factory";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    { 
      provide: API_BASE_URL, 
      useFactory: (config: ConfigService) => resolveApiUrl(config),
      deps: [ConfigService] 
    },
    {
      provide: IMAGEKIT_THUMBNAIL_CONFIG,
      useFactory: ImageKitThumbnailConfigFactory,
      deps: [ConfigService]
    },
    // ng-gallery's lightbox uses the legacy @angular/animations triggers.
    provideAnimationsAsync(),
    provideRouter(routes),
    provideGroundworksAuth(() => buildGroundworksAuthConfig(inject(ConfigService))),
  ]
};
